import React, { useState, useRef, useEffect } from "react";
const ColorDropdown = ({ colors, handleInsertColur, colourCodes, isSideDrawer, colorValue }) => {
  const [selectedColor, setSelectedColor] = useState(() => {
    // const defaultColor = colors?.data.find(color => color.colour_code === colourCodes);
    const defaultColor = colors?.data.find((color) => color.colour_code === colourCodes) || colors?.data[0];
    console.log(colors, colourCodes, "helocolor");

    if (defaultColor) {
      console.log(defaultColor, "defaultcolor");

      handleInsertColur(defaultColor.colour_code);
      return defaultColor;
    }
    return "";
  });
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleOptionChange = (color) => {
    setSelectedColor(color);
    handleInsertColur(color.colour_code);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`flex item-center h-fit `} ref={dropdownRef}>
      <button
        onClick={handleDropdownToggle}
        type="button"
        className="flex items-center p-2 justify-center w-[24px] h-[24px] rounded-sm bg-[#CECECE4D] shadow-sm hover:bg-[#8181814d]"
      >
        <i
          className="bi bi-palette-fill cursor-pointer"
          style={{ color: selectedColor ? selectedColor.colour_code : "#008937 " }}
        ></i>
      </button>
      {isOpen && (
        <div className="dropdown-menu-color w-fit px-2  ml-[-20px] pb-2 mt-1 ">
          {colors?.data.map((color) => (
            <label key={color.colour_code} className="flex cursor-pointer px-1 pt-1">
              <input
                type="checkbox"
                name="colour_code"
                id="colour_code"
                value={color.colour_code}
                // checked={selectedColor && selectedColor.colour_name === color.colour_name}
                onChange={() => handleOptionChange(color)}
                style={{ backgroundColor: color.colour_code, borderColor: "" }}
                className="cursor-pointer mx-1 rounded-full color-circle "
              />
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColorDropdown;
